import React from 'react'
import sortBy from 'lodash/sortBy'
import {OrderItemCard} from '../OrderItemCard'
import {CategoryOrder} from '../../../../store/enumTS'
import {OrderLookProduct} from '../../types/eventData'
import {onOrderItemClick, getOrderItemKitsById, getAllOrderItemsById} from './utils'
import {OrderItemsListProps, OrderLookProductById} from './types'

export const OrderItemsList: React.FC<OrderItemsListProps> = ({
  userOrderItemClick,
  wrapperClassName,
  eventOrder,
  hasAllItemsSelected,
}) => {
  const [selectedItems, setSelectedItems] = React.useState<OrderLookProductById>({})
  const orderItemKitsById = getOrderItemKitsById(eventOrder)

  const orderListDataSorted = sortBy(eventOrder.orderLookProducts, [
    (orderLookProduct) => CategoryOrder[orderLookProduct.product.category],
  ])

  React.useEffect(() => {
    if (hasAllItemsSelected && eventOrder) {
      setSelectedItems(getAllOrderItemsById(eventOrder))
    }
  }, [hasAllItemsSelected, eventOrder])

  return (
    <div className={wrapperClassName}>
      {orderListDataSorted.map((item: OrderLookProduct) => (
        <OrderItemCard
          item={item}
          key={item.id}
          onOrderItemClick={(orderItem: OrderLookProduct) =>
            onOrderItemClick(
              orderItem,
              selectedItems,
              setSelectedItems,
              userOrderItemClick,
              orderItemKitsById,
            )
          }
          isClickable={!!userOrderItemClick}
          isSelected={selectedItems && !!selectedItems[item.id]}
        />
      ))}
    </div>
  )
}
